import {Component, OnDestroy, OnInit} from "@angular/core";
import {firstValueFrom} from "rxjs";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {CustomerService} from "../../../customer/customer.service";
import {BankAccount, Company} from "../../../company/company.model";
import {CompanyService} from "../../../company/company.service";
import {WorkflowCspService} from "../workflow-csp.service";
import {WorkflowCspChangeCuComponent} from "../workflow-csp-change-cu.component";
import {runInAction} from "mobx";

@Component({
    selector: 'app-workflow-csp-one-downgrade-cu',
    templateUrl: './workflow-csp-one-downgrade-cu.component.html',
    standalone: false
})
export class WorkflowCspOneDowngradeCuComponent extends WorkflowCspChangeCuComponent implements OnInit, OnDestroy {
  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected customerService: CustomerService,
              protected workflowCspService: WorkflowCspService,
              protected companyService:CompanyService) {
    super(route, router, subscriptionService, buyService, m, customerService, workflowCspService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('downgrade-cu');
    this.checkOnInitPaymentStep(['address']);
    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    return +this.model.subscription.users === this.model.cu
      || +this.model.subscription.users < this.model.cu;
  }

  onDowngradeInfo(e: any) {
    this.navigate(['address']);
  }

  public onDowngradeInfoBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-cu', this.applianceId]);
  }

  public onInvoiceAddressBack() {
    this.navigate(['info']);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmUpgrade().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
